import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, PRODUCTS, CONTACT, IMAGES } from "@/data/content";
import { Reveal } from "@/components/motion";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-black/10 bg-mist">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-12">
        <div className="grid md:grid-cols-12 gap-12 lg:gap-8">
          <div className="md:col-span-5">
            <Reveal>
              <div className="flex items-center gap-4">
                <img
                  src={IMAGES.logo}
                  alt="AA GULF FZE logo"
                  data-testid="footer-logo"
                  className="h-14 w-14 object-contain"
                />
                <p className="font-display font-semibold text-2xl tracking-tight uppercase text-ink">
                  AA Gulf <span className="font-mono text-xs text-brand align-top">FZE</span>
                </p>
              </div>
              <p className="mt-6 text-black/55 font-light leading-relaxed max-w-sm">
                A leading force in the energy trading industry — trading the products that
                power industries, economies, and lives.
              </p>
              <p className="mt-8 font-mono text-[11px] tracking-[0.25em] uppercase text-black/45">
                {CONTACT.location}
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-2">
            <Reveal delay={0.1}>
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-black/40">
                Navigate
              </p>
              <ul className="mt-6 space-y-3">
                {NAV_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                      className="text-black/60 hover:text-brand transition-colors duration-300 text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <div className="md:col-span-2">
            <Reveal delay={0.15}>
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-black/40">
                Products
              </p>
              <ul className="mt-6 space-y-3">
                {PRODUCTS.map((p) => (
                  <li key={p.code}>
                    <Link
                      to="/products"
                      data-testid={`footer-product-${p.code.toLowerCase()}`}
                      className="text-black/60 hover:text-brand transition-colors duration-300 text-sm"
                    >
                      {p.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <div className="md:col-span-3">
            <Reveal delay={0.2}>
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-black/40">
                Collaborate
              </p>
              <p className="mt-6 text-black/60 font-light text-sm leading-relaxed">
                Collaborate with us for exciting business opportunities.
              </p>
              <Link
                to="/contact"
                data-testid="footer-cta-contact"
                className="mt-8 inline-flex group items-center gap-2 border border-black/25 px-6 py-3 font-mono text-[11px] tracking-[0.2em] uppercase text-ink hover:bg-ink hover:text-paper transition-colors duration-300"
              >
                Contact Us
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Reveal>
          </div>
        </div>

        <div className="mt-24 overflow-hidden select-none" aria-hidden="true">
          <p className="font-display font-semibold uppercase tracking-tighter leading-[0.85] text-outline whitespace-nowrap text-[clamp(4rem,14vw,13rem)]">
            AA Gulf FZE
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-black/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40">
            © {new Date().getFullYear()} AA GULF FZE · Oil Traders in UAE
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-black/40">
            Fuel Oil · MHO · Diesel · Crude Oil
          </p>
        </div>
      </div>
    </footer>
  );
}
